import XcolumnFunc from "@/pcomponents/common/xcolumn/xcolumn/xcolumn_func";
//const xColumnArr=getXcolumnJson();

const getXcolumnJson=()=>{
  let initData:any={
    table:"daily_prescribe",
    list_id:"daily_prescribe_history",
    x_column_list_arr:[
      {"key":"a_stu_name","name":"학생","width":"100","is_show":"1"},
      {"key":"a_write_date","name":"작성일","width":"110","is_show":"1"},
      {"key":"a_subject","name":"과목","width":"80","is_show":""},

      {"key":"a_issue","name":"이슈","width":"200","is_show":"1"},
      {"key":"a_homework_plan","name":"숙제plan","width":"170","is_show":"1"},
      {"key":"a_homework_amount","name":"숙제량","width":"80","is_show":"1"},
      {"key":"a_progress_plan","name":"진도plan","width":"170","is_show":"1"},
      {"key":"a_progress_amount","name":"진도량","width":"80","is_show":"1"},
      {"key":"a_memo","name":"메모","width":"170","is_show":"1"},

      {"key":"a_writer_name","name":"작성자","width":"110","is_show":"1"},
    ],
    list_opt_origin:{
      'now_page':1,
      'num_per_page':100,
      'order_id':'a_stu_name, a_write_date DESC, a_create_date DESC',
      'order_type':'',
      's_date_type':'a_write_date',
      's_start_date':'',
      's_end_date':'',
      'sc':{},
      "is_add_idx_info":"1",
    },
    order_id_col_arr:[
      {"value":"","text":"없음"},
    ]
  };
  initData.pri_col_arr=["a_ymd","a_seq"];
  const xColumnArr:any=XcolumnFunc.getDefaultXcolumn(initData);
  xColumnArr.order_id_col_arr=[
    {value:"a_write_date",text:"작성일"},
    {value:"a_stu_name",text:"학생"},
    {value:"a_writer_name",text:"작성자"},
    {value:"a_subject",text:"과목"},
    {value:"a_create_date",text:"작성일"},
  ];

  return xColumnArr;
};

export default getXcolumnJson;